<template>
	<v-card :key="page_key" :loading="loading" class="ma-2 elevation-0" color="grey lighten-4">
		<v-card-title class="secondary--text">Locum Search Tools </v-card-title>
		<v-row>
			<v-card-text>
				<v-row class="pa-2 justify-center text-center">
					<v-card
						v-for="(condition, key) in orConditions"
						:key="'or_' + key"
						class="mt-3 pl-5 ml-5 justify-center text-center mr-5 pr-5 pb-3"
						justify="center"
						align="center"
						:elevation="2"
						width="100%"
					>
						<v-card-actions>
							<v-btn x-small color="primary" absolute right fab elevation="2" @click="removeOrCondition(key)">
								<v-icon>mdi-minus</v-icon>
							</v-btn>
						</v-card-actions>
						<v-card-text>
							<v-card
								v-for="(and_condition, and_key) in condition"
								:key="'and_' + and_key"
								color="grey lighten-2"
								class="mt-2 pl-5 ml-5 justify-center text-center ml-5 mr-5 pr-5 pb-3 mb-3"
								justify="center"
								align="center"
								:elevation="3"
								width="100%"
							>
								<v-card-actions>
									<v-btn x-small color="primary" absolute right fab elevation="2" @click="removeAndCondition(and_key, key)">
										<v-icon>mdi-minus</v-icon>
									</v-btn>
								</v-card-actions>
								<v-card-text v-if="and_condition.type == 'none'" class="pl-5">
									<v-select
										v-model="and_condition.type"
										class="pa-3 pl-5"
										dense
										label="Filter by"
										value="'none'"
										:items="['industry/expertise', 'attribute']"
										@input="a => onChangeFilterType(a, and_key, key)"
									></v-select>
								</v-card-text>
								<v-card-title v-if="and_condition.type != 'none'" class="pl-5"> filter by {{ and_condition.type }} </v-card-title>

								<v-card-text v-if="and_condition.type == 'industry/expertise'">
									<v-row>
										<v-col>
											<v-select
												v-model="and_condition.industry"
												dense
												label="industry"
												:items="industriesOptions"
												item-text="industry"
												item-value="industry"
												@input="a => onUpdateIndustryCondition(a, and_key, key)"
											></v-select>
										</v-col>
										<v-col>
											<v-select
												v-model="and_condition.expertise"
												dense
												multiple
												deletable-chips
												label="expertise"
												:items="'industry' in and_condition ? industriesOptions.filter(industry => industry.industry == and_condition.industry) : ['ALL']"
												item-text="expertise"
												item-value="expertise"
											></v-select>
										</v-col>
									</v-row>
								</v-card-text>
								<v-card-text v-if="and_condition.type == 'attribute'">
									<v-row>
										<v-col>
											<v-select
												v-model="and_condition.fieldToMatch"
												:item-value="'value'"
												item-text="text"
												label="attribute"
												:items="byFieldsNames"
											></v-select>
										</v-col>
										<v-col v-if="typeof and_condition.fieldToMatch == 'string'" class="font-weight-bold">
											<v-select
												v-model="and_condition.comparator"
												persistent-hint
												:item-value="'value'"
												item-text="text"
												hint="select comparison"
												label="comparator"
												:items="comparatorOptions"
											></v-select>
										</v-col>
										<v-col v-if="typeof and_condition.fieldToMatch == 'object' && and_condition.fieldToMatch.arguments.length > 0">
											<v-row>
												<v-col v-for="(argument, argument_index) in and_condition.fieldToMatch.arguments" :key="key + and_key + argument_index">
													<v-text-field v-if="argument.type == 'string'" v-model="argument.value" dense label="value"></v-text-field>
													<v-select v-if="argument.type == 'boolean'" v-model="argument.value" :items="['NO', 'YES']"></v-select>
													<v-menu
														v-if="argument.type == 'date_selector'"
														ref="menu"
														v-model="argument.menu"
														:close-on-content-click="true"
														transition="scale-transition"
														offset-y
														min-width="290px"
													>
														<template #activator="{ on, attrs }">
															<v-text-field
																v-model="argument.value"
																label="Date"
																type="date"
																hint="Select or type the date (YYYY/MM/DD)"
																persistent-hint
																v-bind="attrs"
																v-on="on"
															></v-text-field>
														</template>
														<v-date-picker ref="picker" v-model="argument.value" min="1950-01-01"></v-date-picker>
													</v-menu>
													<v-select v-if="argument.type == 'date_comparator'" v-model="argument.value" :items="dateComparatorOptions"></v-select>
													<v-card-text v-if="argument.type == 'constant'" readonly :value="argument.value" class="font-weight-bold">{{
														argument.value
													}}</v-card-text>
												</v-col>
											</v-row>
										</v-col>
										<v-col v-else-if="typeof and_condition.fieldToMatch == 'string'">
											<v-text-field v-model="and_condition.valueToMatch" dense label="value"></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
								<v-row justify="center" align="center" class="pa-2">
									<v-btn
										:disabled="and_key == condition.length - 1 ? false : true"
										:color="and_key == condition.length - 1 ? 'primary' : ''"
										fab
										bottom
										absolute
										class="font-weight-bold mt-n7"
										x-small
										@click="newAndCondition(key)"
										>{{ and_key == condition.length - 1 ? '+' : '' }}AND</v-btn
									>
								</v-row>
								<!-- end AND card -->
							</v-card>

							<v-row justify="center" align="center" class="pa-3 mt-0 pt-0">
								<v-btn
									:disabled="key == orConditions.length - 1 ? false : true"
									:color="key == orConditions.length - 1 ? 'primary' : ''"
									fab
									bottom
									absolute
									class="font-weight-bold mt-n7"
									x-small
									@click="newOrCondition"
									>{{ key == orConditions.length - 1 ? '+' : '' }}OR</v-btn
								>
							</v-row>
						</v-card-text>
					</v-card>
				</v-row>

				<v-row class="pa-2">
					<v-col>
						<v-btn :loading="loading" @click="doSearch = true">Search</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-row>

		<v-row>
			<v-card-text v-if="locums.length > 0">
				<v-row>
					<v-col>
						<v-divider></v-divider>
						<v-divider></v-divider>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-data-table
							:headers="[
								{ text: 'actions', value: 'id' },
								{ text: 'email', value: 'email' },
							]"
							fixed-header
							:items="locums"
							:items-per-page="5"
							class="elevation-1"
						>
							<!-- <template v-slot:item.experience="{ item }" >
                <div v-if="item && 'experience' in item">
                  <v-list-item v-for="(value,field) in item.experience" :key="field">
                    <v-chip>{{field}} : {{value}}</v-chip>
                  </v-list-item>
                </div>
                <div v-else><v-chip color="red">Not Provided</v-chip></div>
              </template> -->
							<template #item.id="{ item }">
								<v-row>
									<v-btn class="white--text mx-1" color="primary" rounded :aria-label="item" @click="viewLocum(item)">view locum</v-btn>
									<v-btn class="white--text mx-1" color="secondary" rounded :aria-label="item" @click="enableImpersonation(item.id)">impersonate</v-btn>
								</v-row>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>

			<v-card-actions class="pa-3 justify-center text-center">
				<v-row class="pl-2" justify="center" align="center">
					<v-col class="justify-center text-center">
						<vue-json-to-csv
							:json-data="locumCSVData"
							:labels="locumFieldLabels"
							csv-title="Locum Search Tool Export"
							@success="val => handleCSVSuccess(val)"
							@error="val => handleCSVError(val)"
						>
							<v-btn class="white--text" color="primary" rounded :disable="false">Export Results</v-btn>
						</vue-json-to-csv>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-row>
	</v-card>
</template>

<script>
import moment from 'moment';
import { bus } from '@/main';
import { Parser } from 'json2csv';
import router from '@/router';
import VueJsonToCsv from 'vue-json-to-csv';

import axios from 'axios'; //be able to make requests.
import store from '@/store'; //expose the vuex store, jwt token and user.
import { getAllIndustriesProfessions, setImpersonatedUser } from '@utils';

/*
TODO implement these features.
improve design
locations,

TODO edit locum profile feature


*/

export default {
	name: 'LocumSearchTool',
	components: { VueJsonToCsv },
	data: () => ({
		industriesConfigsObj: store.getters.configs.industries,
		industriesV2: store.getters.configs.industriesV2,
		industryOptionsItems: [],
		page_key: 0,
		loading: false,
		doSearch: false,

		results_headers: [{ text: 'email', value: 'email' }],

		orConditions: store.getters.adminLastSearch?.orConditions || [[{ type: 'none' }]],

		comparatorOptions: ['exactly matches', 'contains', 'does not contain', 'starts with', 'ends with'],

		dateComparatorOptions: ['after', 'before', 'between'],

		byFieldsNames: [
			'professional_number',
			'professional_body',
			'short_bio',
			'isDeleted',
			'updatedBy',
			'email',
			'createdBy',
			'locations',
			{ divider: true },

			{ header: 'Name' },
			'first_name',
			'last_name',
			{ divider: true },

			{ header: 'Last Updated' },
			{
				text: 'last updated on',
				value: {
					arguments: [{ type: 'date_selector', value: null }],
					f: 'flastUpdatedOn',
					flastUpdatedOn: function flastUpdatedOn(locum, lastUpdatedFrom) {
						return 'updatedAt' in locum && moment(moment(locum.updatedAt).format('YYYY-MM-DD')).isSame(lastUpdatedFrom.value);
					},
				},
			},
			{
				text: 'last updated after',
				value: {
					arguments: [{ type: 'date_selector', value: null }],
					f: 'flastUpdatedAfter',
					flastUpdatedAfter: function flastUpdatedAfter(locum, lastUpdatedFrom) {
						return 'updatedAt' in locum && moment(moment(locum.updatedAt).format('YYYY-MM-DD')).isAfter(lastUpdatedFrom.value);
					},
				},
			},
			{
				text: 'last updated before',
				value: {
					arguments: [{ type: 'date_selector', value: null }],
					f: 'flastUpdatedBefore',
					flastUpdatedBefore: function flastUpdatedBefore(locum, lastUpdatedFrom) {
						return 'updatedAt' in locum && moment(moment(locum.updatedAt).format('YYYY-MM-DD')).isBefore(lastUpdatedFrom.value);
					},
				},
			},

			{ divider: true },

			{ header: 'Created At' },
			{
				text: 'created on',
				value: {
					arguments: [{ type: 'date_selector', value: null }],
					f: 'flastCreatedOn',
					flastCreatedOn: function flastCreatedOn(locum, lastUpdatedFrom) {
						return 'createdAt' in locum && moment(moment(locum.createdAt).format('YYYY-MM-DD')).isSame(lastUpdatedFrom.value);
					},
				},
			},
			{
				text: 'created after',
				value: {
					arguments: [{ type: 'date_selector', value: null }],
					f: 'fcreatedAfter',
					fcreatedAfter: function fcreatedAfter(locum, lastUpdatedFrom) {
						return 'createdAt' in locum && moment(moment(locum.createdAt).format('YYYY-MM-DD')).isAfter(lastUpdatedFrom.value);
					},
				},
			},
			{
				text: 'created before',
				value: {
					arguments: [{ type: 'date_selector', value: null }],
					f: 'fCreatedBefore',
					fCreatedBefore: function fCreatedBefore(locum, lastUpdatedFrom) {
						return 'createdAt' in locum && moment(moment(locum.createdAt).format('YYYY-MM-DD')).isBefore(lastUpdatedFrom.value);
					},
				},
			},

			{ divider: true },

			{ header: 'Approved' },
			{
				text: 'is approved',
				value: {
					arguments: [],
					f: 'fisApproved',
					fisApproved: function fisApproved(locum) {
						return 'approved' in locum && locum.approved;
					},
				},
			},
			{
				text: 'is not approved',
				value: {
					arguments: [],
					f: 'fisNotApproved',
					fisNotApproved: function fisNotApproved(locum) {
						return !('approved' in locum) || !locum.approved;
					},
				},
			},
			{ divider: true },

			// "approved",
			'payment_info',
			'id',
			'willing_to_travel',
			'experience',
			'terms_conditions',
			'contact',
			'idpassport',
			// "createdAt",
			'address',
			'isActive',

			'qualifications',
			'working_hours',
			// "updatedAt",
		],

		locums: [],

		locumFieldLabels: {
			first_name: { title: 'First Name' },
			last_name: { title: 'Last Name' },
			idpassport: { title: 'ID Passport' },
			email: { title: 'Email' },
			contact: { title: 'Contact' },
			address: { title: 'Address' },
			payment_info: { title: 'Payment Info' },
			industry: { title: 'Industry' },
			profession: { title: 'Profession' },
			professional_number: { title: 'Professional Number' },
			indemnity_insurance: { title: 'Idemnity Insurance' },
			qualifications: { title: 'Qualifications' },
			experience: { title: 'Experience' },
			working_hours: { title: 'Working Hours' },
			locations: { title: 'Locations' },
			skills: { title: 'Skills' },
			willing_to_travel: { title: 'Willing To Travel' },
			short_bio: { title: 'Short Bio' },
			id: { title: 'ID' },
			tenantId: { title: 'Tenant Id' },
			isDeleted: { title: 'Deleted' },
			isActive: { title: 'Active' },
			approved: { title: 'Approved' },
			registered_date: { title: 'Registered Date' },
			createdAt: { title: 'Created At' },
			createdBy: { title: 'Created By' },
			updatedAt: { title: 'Created At' },
			updatedBy: { title: 'Created by' },
			idDocument: { title: 'ID Document' },
			profilePicture: { title: 'Profile Picture' },
			provisionalTax: { title: 'Provisional Tax' },
			profIndemnity: { title: 'ProfIndemnity' },
		},
	}),
	computed: {
		// parses the locum data so that the CSV will populate properly
		locumCSVData() {
			const data = [];
			this.locums.forEach(locum => {
				const parsed = {};
				for (const key in locum) {
					if (key == 'address') {
						let string = '';
						for (const subKey in locum[key]) {
							string += `${locum[key][subKey]}, `;
						}
						parsed[key] = string;
					} else if (key == 'payment_info' || key == 'qualifications' || key == 'experience' || key == 'indemnity_insurance') {
						let string = '';
						for (const subKey in locum[key]) {
							string += `${subKey}: ${locum[key][subKey]}, `;
						}
						parsed[key] = string;
					} else if (key == 'short_bio') {
						let string = `${locum[key]}`;
						parsed[key] = string;
					} else if (key == 'working_hours') {
						let string = '';
						for (const subKey in locum[key]) {
							string += `${subKey}: {`;
							for (const subInnerKey in locum[key][subKey]) {
								string += `${subInnerKey}: ${locum[key][subKey][subInnerKey]}, `;
							}
							string += `}, `;
						}
						parsed[key] = string;
					} else parsed[key] = locum[key];
				}
				data.push(parsed);
			});

			return data;
		},
		industriesOptions() {
			return this.industryOptionsItems;
		},
	},
	watch: {
		doSearch: async function (val) {
			if (val) {
				this.loading = true;
				await this.on_search();
				this.doSearch = false;
			}
		},
	},
	async mounted() {
		this.industryOptionsItems = getAllIndustriesProfessions(this.industriesConfigsObj);
		// if a search is found apply the search when getting to component
		const search = store.getters.adminLastSearch;
		if (search && (search.orConditions != [] || search.core_search != [])) this.on_search(search);
	},
	methods: {
		// called if the CSV export/creation fails
		handleCSVError(value) {
			console.error('CSV EXPORT ERROR', value);
		},

		// called if the CSV export/creation was successfull
		handleCSVSuccess() {},

		copyTextToClipboard(text) {
			var textArea = document.createElement('textarea');

			//
			// *** This styling is an extra step which is likely not required. ***
			//
			// Why is it here? To ensure:
			// 1. the element is able to have focus and selection.
			// 2. if the element was to flash render it has minimal visual impact.
			// 3. less flakyness with selection and copying which **might** occur if
			//    the textarea element is not visible.
			//
			// The likelihood is the element won't even render, not even a
			// flash, so some of these are just precautions. However in
			// Internet Explorer the element is visible whilst the popup
			// box asking the user for permission for the web page to
			// copy to the clipboard.
			//

			// Place in the top-left corner of screen regardless of scroll position.
			textArea.style.position = 'fixed';
			textArea.style.top = 0;
			textArea.style.left = 0;

			// Ensure it has a small width and height. Setting to 1px / 1em
			// doesn't work as this gives a negative w/h on some browsers.
			textArea.style.width = '2em';
			textArea.style.height = '2em';

			// We don't need padding, reducing the size if it does flash render.
			textArea.style.padding = 0;

			// Clean up any borders.
			textArea.style.border = 'none';
			textArea.style.outline = 'none';
			textArea.style.boxShadow = 'none';

			// Avoid flash of the white box if rendered for any reason.
			textArea.style.background = 'transparent';

			textArea.value = text;

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				var successful = document.execCommand('copy');
				successful ? 'successful' : 'unsuccessful';
			} catch (err) {
				console.error('Unable to copy');
			}

			document.body.removeChild(textArea);
		},

		exportResults() {
			var input = this.locums;

			const fields = [
				{
					label: 'companies worked for',
					value: locum => {
						if (Object.keys(locum).includes('experience') && Object.keys(locum.experience).includes('companies_worked_for')) {
							return locum.experience.companies_worked_for.join(' and ');
						} else {
							return 'empty';
						}
					},
					default: 'empty',
				},
				'professional_number',
				'contact',
				'industry',
				'idpassport',
				'professional_body',
				'short_bio',
				'address.province',
				'address.region',
				'address.suburb',
				'email',
				{
					label: 'locations',
					value: locum => (Object.keys(locum).includes('locations') ? locum.locations.join(' and ') : 'empty'),
				},
				{
					label: 'documents',
					value: locum => {
						if (Object.keys(locum).includes('documents') && Object.keys(locum.documents).includes('images') && locum.documents.images.length > 0) {
							return locum.documents.images.join(' and ');
						} else {
							return 'empty';
						}
					},
				},
				{
					label: 'languages',
					value: locum => (Object.keys(locum).includes('languages') ? locum.languages.join(' and ') : 'empty'),
				},
				'last_name',
				'qualifications.qualification',
				'qualifications.institution',
				'qualifications.other_qualifications',
				'qualifications.year_qualified',
				'working_hours.saturday.start',
				'working_hours.saturday.end',
				'working_hours.saturday.rate',
				'working_hours.sundays.start',
				'working_hours.sundays.end',
				'working_hours.sundays.rate',
				'working_hours.weekdays.start',
				'working_hours.weekdays.end',
				'working_hours.weekdays.rate',
				'working_hours.public_holidays.start',
				'working_hours.public_holidays.end',
				'working_hours.public_holidays.rate',
				'updatedAt',
				'first_name',
				'payment_info.branch_code',
				'payment_info.indemnity_insurance',
				'payment_info.account_number',
				'payment_info.account_type',
				'payment_info.tax_payer',
				'payment_info.account_holder',
				'payment_info.tax_number',
				'payment_info.bank_name',
				'id',
				'profession',
				'willing_to_travel',
				'approved',
				'isActive',
				'terms_conditions',
				'createdAt',
				'updatedBy',
				'isDeleted',
				'createdBy',
				'registered_date',
				'indemnity_insurance.has_indemnity_insurance',
				'indemnity_insurance.indemnity_insurance_expiry',
			];

			try {
				const parser = new Parser({ fields });
				const csv = parser.parse(input);
				this.copyTextToClipboard(csv);
			} catch (err) {
				console.error('jsonparser', err);
			}
		},

		viewLocum(locum) {
			store.commit('SET_ADMIN_VIEW_LOCUM', locum); //refresh the users state. await it completed.
			bus.$emit('change-main-context', 'ViewLocumProfile');
		},
		async enableImpersonation(id) {
			const success = await setImpersonatedUser('locum', id);
			if (!success) {
				return alert('User not found');
			}
			router.push('/locum/dashboard');
		},

		//due to limitations we must get all results from an expertise/indsutry search collection before we can perform other softer filters on the results.
		//there fore the core_search() method will only accept a list of industries and expertises
		//an industry is only given if ALL expertises in it are considered.
		//an indsutry_expertise pair is given if only that expertise is considered
		async core_search(industry_expertise_pair) {
			let searches = [];
			industry_expertise_pair.forEach(pair => {
				if (pair.expertise == '*' && pair.industry == '*') {
					//search all case
					//push multiple urls for every industry and every expertise
					this.industriesOptions.forEach(item => {
						searches.push(store.getters.getAPI + '/professionals/search/' + item.expertise);
					});
				} else {
					if (pair.expertise == '*' && pair.industry != '*') {
						//search all in industry case
						this.industriesOptions
							.filter(item => item.industry == pair.industry)
							.forEach(item => {
								searches.push(store.getters.getAPI + '/professionals/search/' + item.expertise);
							});
					} else if (pair.expertise != '*' && pair.industry != '*') {
						//search singular specific case
						this.industriesOptions
							.filter(item => item.industry == pair.industry && item.expertise == pair.expertise)
							.forEach(item => {
								searches.push(store.getters.getAPI + '/professionals/search/' + item.expertise);
							});
					}
				}
			});

			//remove duplicates :
			searches = searches.filter(function (item, pos, self) {
				return self.indexOf(item) == pos;
			});
			//here we convert from URL strings to axios requests, execute those requests, for each request apply the remainder of the filter for this search.
			const token = store.getters.jwtToken;
			searches = searches.map(url => axios.get(url, { headers: { Authorization: token } }));
			let responses = await axios.all(searches);
			let output = [];
			responses
				.map(response => response.data.data.Items)
				.forEach(search_response => {
					search_response.forEach(locum => {
						output.push(locum);
					});
				});
			return output;
		},

		newOrCondition() {
			this.orConditions.push([{ type: 'none' }]);
			this.plus_page_key();
		},

		newAndCondition(orKey) {
			this.orConditions[orKey].push({ type: 'none' });
			this.plus_page_key();
		},

		removeOrCondition(key) {
			if (key > 0) {
				this.orConditions = [...this.orConditions.slice(0, key), ...this.orConditions.slice(key + 1)];
			} else {
				this.orConditions = [...this.orConditions.slice(1)];
			}
			if (this.orConditions.length == 0) {
				this.orConditions = [[{ type: 'none' }]];
			}
			this.plus_page_key();
		},

		removeAndCondition(andKey, orKey) {
			if (andKey > 0) {
				this.orConditions[orKey] = [...this.orConditions[orKey].slice(0, andKey), ...this.orConditions[orKey].slice(andKey + 1)];
			} else {
				this.orConditions[orKey] = [...this.orConditions[orKey].slice(1)];
			}
			if (this.orConditions[orKey].length == 0) {
				this.orConditions[orKey] = [{ type: 'none' }];
			}
			this.plus_page_key();
		},

		onChangeFilterType(value, andKey, orKey) {
			this.orConditions[orKey][andKey].type = value;
			this.plus_page_key();
		},

		onUpdateIndustryCondition(value, andKey, orKey) {
			this.orConditions[orKey][andKey].industry = value;
			this.orConditions[orKey][andKey].expertise = [];
			this.plus_page_key();
		},

		onUpdateExpertiseCondition(value, index) {
			if (value.find(expertise => expertise == 'ALL')) {
				this.orConditions[index].expertise = ['ALL'];
			}
			this.plus_page_key();
		},

		async on_search(lastSearch = null) {
			this.plus_page_key();
			this.locums = [];
			let core_search = lastSearch ? lastSearch.core_search : [];
			const conditions = lastSearch ? lastSearch.orConditions : this.orConditions;

			await conditions.forEach(async OrBlock => {
				//build a core search out of any filters for industry/expertise :
				OrBlock.filter(condition => condition.type == 'industry/expertise').forEach(condition => {
					if (condition.expertise.find(a_expertise => a_expertise == 'ALL')) {
						core_search.push({ industry: condition.industry, expertise: '*' });
					} else {
						condition.expertise.forEach(expertise => {
							core_search.push({ industry: condition.industry, expertise: expertise });
						});
					}
				});
				//add a search all if we dont include a industry or expertise filter in this
				if (OrBlock.filter(condition => condition.type == 'industry/expertise').length == 0) {
					core_search.push({ industry: '*', expertise: '*' });
				}

				//those locums who matched that industry and expertise filter, for each does ALL other filters apply ?
				let result = await this.core_search(core_search);
				let final = [];

				// make sure to store the last search query
				store.commit('SET_ADMIN_LAST_SEARCH', { core_search, orConditions: this.orConditions });

				await result.forEach(async locum => {
					var failedAny = await OrBlock.filter(condition => condition.type == 'attribute').some(attribute_match_condition => {
						if (typeof attribute_match_condition.fieldToMatch == 'string') {
							if (attribute_match_condition.comparator == 'exactly matches') {
								return !(
									attribute_match_condition.fieldToMatch in locum && attribute_match_condition.valueToMatch == locum[attribute_match_condition.fieldToMatch]
								);
							} else if (attribute_match_condition.comparator == 'contains') {
								return !(
									attribute_match_condition.fieldToMatch in locum &&
									locum[attribute_match_condition.fieldToMatch].indexOf(attribute_match_condition.valueToMatch) > -1
								);
							} else if (attribute_match_condition.comparator == 'does not contain') {
								return !(
									attribute_match_condition.fieldToMatch in locum &&
									locum[attribute_match_condition.fieldToMatch].indexOf(attribute_match_condition.valueToMatch) == -1
								);
							} else if (attribute_match_condition.comparator == 'starts with') {
								return !(
									attribute_match_condition.fieldToMatch in locum &&
									locum[attribute_match_condition.fieldToMatch].startsWith(attribute_match_condition.valueToMatch)
								);
							} else if (attribute_match_condition.comparator == 'ends with') {
								return !(
									attribute_match_condition.fieldToMatch in locum &&
									locum[attribute_match_condition.fieldToMatch].endsWith(attribute_match_condition.valueToMatch)
								);
							} else {
								return true;
							}
						} else {
							const f_name = attribute_match_condition.fieldToMatch.f;

							return !attribute_match_condition.fieldToMatch[f_name](locum, ...attribute_match_condition.fieldToMatch.arguments);
						}
					}); //append more filters via a OR operator to this point, for left to right early exit. Return TRUE if the filter fails.

					if (!failedAny) {
						await final.push(locum);
					}
				});

				this.loading = false;
				//finally push the filter into here.
				this.locums.push(...final);
			});
		},

		plus_page_key() {
			this.page_key += 1;
		},
	},
};
</script>
